import { CSSProperties } from 'react';

/** Shared layout for Approve / Reject / Cancel in review flows */
export const cashieringReviewToolbarActionsStyle: CSSProperties = {
  display: 'flex',
  gap: '1rem',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'flex-start',
};

/** Primary / destructive action buttons (Approve, Reject, Cancel entity) */
export const cashieringReviewToolbarButtonStyle: CSSProperties = {
  minWidth: 120,
  fontSize: '1.1em',
  fontWeight: 600,
  padding: '0.75em 1.5em',
  display: 'flex',
  alignItems: 'center',
  gap: '0.5em',
};

/** Close / back control — aligned with toolbar action sizing */
export const cashieringReviewCloseButtonStyle: CSSProperties = {
  minWidth: 120,
  fontWeight: 600,
  display: 'flex',
  alignItems: 'center',
  gap: '0.5em',
  height: 48,
  padding: '0.75em 1.5em',
  fontSize: '1.1em',
};

/** Full-width callout when approval is blocked (pending deps, missing docs, etc.) */
export const cashieringReviewBlockingCalloutStyle: CSSProperties = {
  flexBasis: '100%',
  margin: 0,
  padding: '0.75rem 1rem',
  borderRadius: 'var(--radius)',
  border: '1px solid rgba(255, 191, 71, 0.45)',
  background: 'rgba(255, 191, 71, 0.08)',
  color: 'var(--gold, #ffbf47)',
  fontSize: '0.8125rem',
  lineHeight: 1.5,
};
